import { fetchUserData } from './fetchUserData'
import { logoutUser } from './logoutUser'

export const AuthController = {
  fetchUserData,
  logoutUser,
}
